/* eslint-disable quotes */
import classNames from 'classnames'
import { Carousel } from 'components/carousels/Carousel'
import { boot, load } from 'components/common/Intercom'
import { useLoading } from 'contexts'
import useTranslation from 'next-translate/useTranslation'
import { useCallback, useRef } from 'react'
import { ContainerElement } from 'types'

export function ReviewsCarouselContainer({
  children,
  className,
}: ContainerElement) {
  const { t } = useTranslation('single_artwork')
  const { setIsIntercomLoaded } = useLoading()

  const reachedCarouselEnd = useRef(false)

  // open intercom when the user reaches the end of the carousel
  const onCarouselEnd = useCallback(() => {
    // don't take action on small screens or if the user was already prompted intercom
    if (window.innerWidth < 1024 || reachedCarouselEnd.current) return

    if (!window.Intercom) {
      load()
      boot()
      setIsIntercomLoaded(true)
    }

    reachedCarouselEnd.current = true
    window.Intercom(
      'showNewMessage',
      "Hi FairArt team, I'd like to learn more about feedback from FairArt collectors."
    )
  }, [])

  return (
    <Carousel
      title={t('reviews_from_fairart_collectors')}
      className={classNames(className, 'bg-warm-50 py-8')}
      bodyClassName='mt-5 sm:mt-6'
      grid={{
        xs: 'w-[calc(66.66%_-_1_/_3_*_theme(margin.4))] min-w-[16.8125rem]',
        md: 'md:w-[calc(33.33%_-_2_/_3_*_theme(margin.4))]',
        lg: 'lg:min-w-[18.6875rem]',
        xl: 'xl:min-w-[24rem] 2xl:min-w-[21.75rem] 2xl:w-[calc(25%_-_3_/_4_*_theme(margin.4))]',
      }}
      onCarouselEnd={onCarouselEnd}
    >
      {children}
    </Carousel>
  )
}
